import { get, set } from './common';
var CredentialsKey = 'credentials:typica';
var CurrentUserKey = 'currentUser:typica';
var getRoleFromPathname = function () {
    return window.location.pathname.split('/')[1];
};
var credentialsKey = function () { return "".concat(getRoleFromPathname(), ":").concat(CredentialsKey); };
export var setCredentials = function (credentials) {
    set(credentialsKey(), credentials);
};
export var getCredentials = function () {
    return get(credentialsKey());
};
var defaultCurrentUser = {
    id: '0',
    name: '',
    email: '',
    role: '',
};
var currentUserKey = function () { return "".concat(getRoleFromPathname(), ":").concat(CurrentUserKey); };
export var setCurrentUser = function (user) {
    set(currentUserKey(), user);
};
export var getCurrentUser = function () {
    var user = get(currentUserKey());
    if (!user)
        return defaultCurrentUser;
    return user;
};
